export default {
  Dashboard: {
    _tag: 'CSidebarNavItem',
    name: 'dashboard',
    phrase: 'dashboard',
    to: '/dashboard',
    order: 1,
    icon: 'fa-solid dashboard-icon',
   roles: ['Admin','Sub Admin'],
  },
}
